import {
	Avatar,
	Box,
	Card,
	Icon,
	IconButton,
	MenuItem,
	Select,
	styled,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	useTheme,
} from '@mui/material';
import { Paragraph } from 'app/components/Typography';
import { useSelector } from 'react-redux';

const CardHeader = styled(Box)(() => ({
	display: 'flex',
	paddingLeft: '24px',
	paddingRight: '24px',
	marginBottom: '12px',
	alignItems: 'center',
	justifyContent: 'space-between',
}));

const Title = styled('span')(() => ({
	fontSize: '1rem',
	fontWeight: '500',
	textTransform: 'capitalize',
}));

const ProductTable = styled(Table)(() => ({
	minWidth: 400,
	whiteSpace: 'pre',
	'& small': {
		width: 50,
		height: 15,
		borderRadius: 500,
		boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)',
	},
	'& td': { borderBottom: 'none' },
	'& td:first-of-type': { paddingLeft: '16px !important' },
}));

const Small = styled('small')(({ bgcolor }) => ({
	width: 50,
	height: 15,
	color: '#fff',
	padding: '2px 8px',
	borderRadius: '4px',
	overflow: 'hidden',
	background: bgcolor,
	boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)',
}));

const TopSellingTable = () => {
	const { palette } = useTheme();
	const bgError = palette.error.main;
	const bgPrimary = palette.primary.main;
	const bgSecondary = palette.secondary.main;
	const { agent, trans } = useSelector((state) => state.home);
	let newA = [];
	let newB = [];
	if (agent && trans) {
		agent &&
			agent?.result?.map((d) => {
				trans &&
					trans?.result?.map((l) => {
						if (l.agent_id === d.id) {
							newA.push({
								...l,
								agent: d,
							});
						}
					});
			});
	}
	if (newA?.length > 0) {
		newB = newA.sort(function (a, b) {
			return b.id - a.id;
		});
	}
	console.log('first', newA);
	return (
		<Card elevation={3} sx={{ pt: '20px', mb: 3 }}>
			<CardHeader>
				<Title>latest transaction</Title>
				{/* <Select size="small" defaultValue="this_month">
          <MenuItem value="this_month">This Month</MenuItem>
          <MenuItem value="last_month">Last Month</MenuItem>
        </Select> */}
			</CardHeader>

			<Box overflow='auto'>
				<ProductTable>
					<TableHead>
						<TableRow>
							<TableCell sx={{ px: 3 }} colSpan={4}>
								Agent Name
							</TableCell>
							<TableCell sx={{ px: 0 }} colSpan={2}>
								Amount
							</TableCell>
							<TableCell sx={{ px: 0 }} colSpan={2}>
								Status
							</TableCell>
							<TableCell sx={{ px: 0 }} colSpan={1}>
								Date/Time
							</TableCell>
						</TableRow>
					</TableHead>

					<TableBody>
						{newB?.map((product, index) => {
							return index < 5 ? (
								<TableRow key={index} hover>
									<TableCell
										colSpan={4}
										align='left'
										sx={{ px: 0, textTransform: 'capitalize' }}>
										<Box display='flex' alignItems='center'>
											<Avatar
												sx={{
													width: 30,
													height: 30,
													bgcolor: 'orange',
													fontSize: 14,
												}}>
												OP
											</Avatar>
											<Paragraph sx={{ m: 0, ml: 4 }}>
												{product.agent.agency_name}
											</Paragraph>
										</Box>
									</TableCell>

									<TableCell
										align='left'
										colSpan={2}
										sx={{ px: 0, textTransform: 'capitalize' }}>
										₹{product.total_amount}
									</TableCell>

									<TableCell sx={{ px: 0 }} align='left' colSpan={2}>
										{product.type === 'CR' ? (
											<Small bgcolor={bgPrimary}>CR</Small>
										) : (
											<Small bgcolor={bgError}>DR</Small>
										)}
									</TableCell>

									<TableCell
										sx={{ px: 0, fontSize: 12 }}
										colSpan={2}
										align='left'>
										{`${product.created_at.split('T')[0]} | ${
											product.created_at.split('T')[1].split('.')[0]
										}`}
									</TableCell>
								</TableRow>
							) : (
								''
							);
						})}
					</TableBody>
				</ProductTable>
			</Box>
		</Card>
	);
};

const productList = [
	{
		imgUrl: '/assets/images/products/headphone-2.jpg',
		name: 'earphone',
		price: 100,
		available: 'CR',
	},
	{
		imgUrl: '/assets/images/products/headphone-3.jpg',
		name: 'earphone',
		price: 1500,
		available: 'DR',
	},
	{
		imgUrl: '/assets/images/products/iphone-2.jpg',
		name: 'iPhone x',
		price: 1900,
		available: 'CR',
	},
	{
		imgUrl: '/assets/images/products/iphone-1.jpg',
		name: 'iPhone x',
		price: 100,
		available: 'CR',
	},
	{
		imgUrl: '/assets/images/products/headphone-3.jpg',
		name: 'Head phone',
		price: 1190,
		available: 'CR',
	},
];

export default TopSellingTable;
